module.exports = __webpack_public_path__ + "img/arr080.d1eb9b25.svg";